module.exports.ExpenseEnumStatus = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  APPROVED: 'APPROVED',
  PAID: 'PAID',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
}

module.exports.ExpenseEnumDocType = {
  BILL: 'BILL',
  RECEIPT: 'RECEIPT',
  NO_DEDUCTIBLE_BILL: 'NO-DEDUCTIBLE-BILL',
}

module.exports.InvoiceEnumStatus = {
  DRAFT: 'DRAFT',
  UNPAID: 'UNPAID',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED',
  CREDIT_NOTE_ISSUED: 'CREDIT-NOTE-ISSUED',
}

module.exports.PaymentEntryEnumType = {
  CHEQUE: 'CHEQUE',
  DEPOSIT: 'DEPOSIT',
  TRANSFER: 'TRANSFER',
  MANUAL: 'MANUAL',
  TRANSFERE: 'TRANSFERE'
}

module.exports.PaymentEntryEnumStatus = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  CANCEL: 'CANCEL',
}

module.exports.PaymentTypeEnumType = {
  CASH: 'CASH',
  BANK: 'BANK',
  OTHER: 'OTHER',
}

module.exports.SaleEnumStatus = {
  DRAFT: 'DRAFT',
  TO_DELIVER_AND_BILL: 'TO DELIVER AND BILL',
  TO_BILL: 'TO BILL',
  TO_DELIVER: 'TO DELIVER',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
}

module.exports.SaleEnumBillingStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  PARTIALLY: 'PARTIALLY',
  CLOSED: 'CLOSED',
}

module.exports.SubscriptionEnumStatus = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  CANCELLED: 'CANCELLED',
}

module.exports.PaymentMethodEnum = {
  ONLINE: 'ONLINE',
  COLLECTOR_CASH: 'COLLECTOR_CASH',
  COLLECTOR_CARD: 'COLLECTOR_CARD',
  CUSTOMER_DEPOSIT: 'CUSTOMER_DEPOSIT'
}